import { useEffect, useState } from 'react'
import type { ReactNode } from 'react'
import { createLayoutStore } from './store'
import type { LayoutStoreConfig } from './store'
import { LayoutStoreContext } from './hooks'
import { registerLayoutStore } from './registry'

interface LayoutStoreProviderProps {
  config: LayoutStoreConfig
  children: ReactNode
}

export function LayoutStoreProvider({ config, children }: LayoutStoreProviderProps) {
  const [handle] = useState(() => createLayoutStore(config))

  // Register the store globally so cross-tree imperative callers (notably
  // `useExpressionLibrary`'s propagation cascade) can mutate it without
  // walking React context. The dispose fires before the store is destroyed
  // below so we never hand out a half-torn-down handle.
  useEffect(() => registerLayoutStore(handle.store), [handle])

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      handle.destroy()
    }
  }, [handle])

  return <LayoutStoreContext value={handle.store}>{children}</LayoutStoreContext>
}
